enum CollectedNftsForAddressStatusToggle {
  All = "all",
  Listed = "listed",
}

export default CollectedNftsForAddressStatusToggle;
